import {action, computed, makeObservable, observable} from "mobx";
import {v4 as uuidv4} from "uuid";

export class UploadInProgress {
  id: string
  sortKey: number
  file: File
  bytesUploaded: number = 0
  saved: false
  title: string
  total : number
  constructor(file: File) {

    this.file = file
    this.id = uuidv4()
    this.title = file.name
    this.total = file.size

    makeObservable(this, {
      bytesUploaded: observable,
      update: action,
      percent: computed,
      finished: computed,
    })
  }

  setDirty() {

  }


  update(bytesUploaded: number) {
    this.bytesUploaded = bytesUploaded
  }

  get percent() {
    return (this.bytesUploaded / this.file.size) * 100
  }

  get finished() {
    return this.bytesUploaded == this.file.size
  }
}